module.exports = "https://cdn.ticketswap.com/_next/static/images/club-nights-6bde293f113e1c53b5076a3e1195c422.jpg";